import { ref } from "vue";
import {
    Resource,
    ResourceState,
    resourceStatePrototype,
    useResourceState,
} from "@/domains/app/resource";

export type Breed = Resource & {
    label: string;
};

export type BreedState = ResourceState<Breed>;

/**
 * Create a breed state to get data and its mutators
 * @param id Id of the breed that the state should be related to
 * @returns a breed state with the data and mutators
 */
export function useBreed(id?: number): BreedState {
    const state: BreedState = {
        data: ref(null),
        apiRoute: "breeds",
        apiErrors: ref(null),
        save: () => resourceStatePrototype.save(state),
        del: () => resourceStatePrototype.del(state),
        init: () =>
            resourceStatePrototype.init(id, state, {
                id: -1,
                label: "",
            }),
    };

    return useResourceState(state);
}
